import { Component, OnInit, Input } from '@angular/core';
import { RestapiService } from '../../services/restapi.service';
import { RoutingService } from '../../services/routing.service';
@Component({
  selector: 'app-card',
  templateUrl: './app-card.component.html',
  // styleUrls: ['./app-card.component.scss']
})
export class AppCardComponent implements OnInit {

  @Input() card: any;
  @Input() conf: any;

  constructor(
    public api: RestapiService,
    public route: RoutingService,
  ) { }

  ngOnInit(): void {

  }

  targetUrl() {
    let link = '';
    switch (this.conf.type) {
      case 'section':
        link = this.conf.route + '/' + this.card.name
        break;
      case 'event':
        link = this.conf.route + '/' + this.card.id
        break;
      default:
        link = this.card.link;
        break;
    }
    this.route.goTo(link);
  }

}
